export async function postData({ url, data, options = {} }) {
    const requestOptions = {
        body: JSON.stringify(data),
        method: options.method ? options.method : 'POST',
        credentials: 'include'
    };
    const response = await fetch(url, requestOptions);
    const { ok, status } = response;
    if (status === 204) {
        return {
            success: true,
            data: {}
        }
    }

    const success = ok && (status >= 200 && status < 204);
    if (options.isBinary) {
        return { success, data: response };
    }
    const json = await response.json();
    return {
        success,
        data: success ? json.data : json
    }
}

export async function getData({ url, options = {} }) {
    const requestOptions = {
        method: 'GET',
        credentials: 'include'
    };
    const response = await fetch(url, requestOptions);
    const { ok, status } = response;
    if (status === 204) {
        return {
            success: true,
            data: {}
        }
    }
    const json = await response.json();
    const success = ok && (status >= 200 && status < 204);
    return {
        success,
        data: success ? json.data : json
    }
}

export function parseErrorMessage(data) {
    const { errors, code } = data;
    if (errors && errors.message) {
        return errors.message;
    }
    if (code === 401) {
        return 'Could not authenticate. Please enter a valid email and password.'
    }
}


// WEBPACK FOOTER //
// ./src/helpers/request.js